<div class="countdown-timer">
  <div class="timer-container" *ngIf="timeLeft > 0">
    <div class="time-box">
      <span class="time-value">{{ hours }}</span>
      <span class="time-label">Horas</span>
    </div>
    <div class="separator">:</div>
    <div class="time-box">
      <span class="time-value">{{ minutes }}</span>
      <span class="time-label">Minutos</span>
    </div>
    <div class="separator">:</div>
    <div class="time-box">
      <span class="time-value">{{ seconds }}</span>
      <span class="time-label">Segundos</span>
    </div>
  </div>
  <div class="expired-message" *ngIf="timeLeft <= 0">
    <p>El tiempo ha terminado.</p>
  </div>
</div>
